import { createStyles, rem } from "@mantine/core"

export const useStyles = createStyles((theme) => ({
    container: {
        display: "flex",
        gap: ".5rem",
    },
    fileInput: {
        ".mantine-FileInput-input": {
            paddingRight: rem(30),
            paddingLeft: rem(40),
            width: rem(234.5),
            minHeight: rem(40),
            height: rem(40),
        },
    },
    select: {
        ".mantine-Select-input": {
            minHeight: rem(40),
            height: rem(40),
        },
    },
    avatar: {
        height: rem(40),
        width: rem(40),
        minWidth: rem(40),
        ".mantine-Avatar-placeholder": {
            backgroundColor: theme.colors.primary[0],
        },
    },
}))
